'use strict';

const fileInputTokens = (theme) => ({
    fileNameTextColor: theme.colors.body.text,
    fileNameBackgroundColor: theme.palette.grey100,
    fileNameBorderRadius: theme.radiuses.m,
    fileNamePaddingX: theme.space.component.x.s,
    fileNamePaddingY: theme.space.component.y.s,
    fileDisabledNameTextColor: theme.palette.grey400,
    fileNameErrorBackgroundColor: theme.colors.danger.alpha,
    fileNameErrorIconColor: theme.colors.danger.normal,
    fileNameValidIconColor: theme.colors.success.normal,
});

exports.fileInputTokens = fileInputTokens;
//# sourceMappingURL=fileInput.js.map
